import React from 'react'
import { useSelector } from 'react-redux';
import { Polyline } from 'react-leaflet';
import {
    visibleAssetsMarkersSelector,
    selectVehicleById
} from '../../../features/assets/assetsSlice';

const OsmTailPath = ({ assetId }) => {
    const vehicle = useSelector(state => selectVehicleById(state, assetId));
    const tail = vehicle?.tail || [];
    const statusMeta = vehicle?.statusMeta || {};

    const visibleAssetMarkers = useSelector(visibleAssetsMarkersSelector);
    const { colorbg } = statusMeta;
    const visible = visibleAssetMarkers.indexOf(assetId) !== -1;

    if (tail && colorbg && visible) {
        let tailPath = [];
        tail.forEach(tailPoint => {
            if (!isNaN(parseFloat(tailPoint.lat)) && !isNaN(parseFloat(tailPoint.lng))) {
                tailPath.push([parseFloat(tailPoint.lat), parseFloat(tailPoint.lng)]);
            }
        });
        tailPath = tailPath.reverse();

        return (
            <Polyline
                positions={tailPath}
                pathOptions={{ color: '#00008B' }}
            />
        );
    } else {
        return null;
    }
}

export default OsmTailPath;